/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nrl_Notrackedletters3Inputs */

const en_coinvestments_nrl_notrackedletters3 = /** @type {(inputs: Coinvestments_Nrl_Notrackedletters3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Non-Release Letters tracked yet`)
};

/**
* | output |
* | --- |
* | "No Non-Release Letters tracked yet" |
*
* @param {Coinvestments_Nrl_Notrackedletters3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nrl_notrackedletters3 = /** @type {((inputs?: Coinvestments_Nrl_Notrackedletters3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nrl_Notrackedletters3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nrl_notrackedletters3(inputs)
});
export { coinvestments_nrl_notrackedletters3 as "coInvestments_nrl_noTrackedLetters" }